const LINK = {
  TARGET: {
    DEFAULT: {
      VALUES: ['_self', '_blank', '_parent', '_top', '_unfencedTop'],
    },
    SELF: {
      VALUE: '_self',
      LABEL: 'داخلی (پیش‌فرض)',
    },
    BLANK: {
      VALUE: '_blank',
      LABEL: 'خارجی (پنجره جدید)',
    },
    PARENT: {
      VALUE: '_parent',
      LABEL: 'صفحه والد',
    },
    TOP: {
      VALUE: '_top',
      LABEL: 'بالاترین صفحه والد',
    },
    UNFENCED_TOP: {
      VALUE: '_unfencedTop',
      LABEL: 'بالای قاب محدود نشده (fenced frame)',
    },
  },
} as const;

export { LINK };
